export const timeDifferenceLessOneYear = (d1) => {
    const date = new Date(d1);
    date.setMonth(date.getMonth() + 13);
    return Date.now() - date.getTime() < 0;
}


export const timeAtLeast18Years = (d1) => {
    const date = new Date(d1);
    date.setFullYear(date.getFullYear() + 18);
    return Date.now() - date.getTime() <= 0;
}

const HK_TIMEZONE_OFFSET = -8 * 60; // Time zone in Hong Kong (GMT+8), Minutes

const hasExplicitTimezone = (dateValue) => {
    if (typeof dateValue !== 'string') {
        return false;
    }

    return /(Z|UTC|HKT|[+-]\d{2}:?\d{2})$/i.test(dateValue.trim());
};

const isOffsetTimezoneToken = (timezoneToken) => {
    const hasLeadingSign = timezoneToken.length === 5 || timezoneToken.length === 6;

    return hasLeadingSign
        && (timezoneToken[0] === '+' || timezoneToken[0] === '-')
        && timezoneToken[1] >= '0' && timezoneToken[1] <= '9'
        && timezoneToken[2] >= '0' && timezoneToken[2] <= '9'
        && timezoneToken[timezoneToken.length - 2] >= '0' && timezoneToken[timezoneToken.length - 2] <= '9'
        && timezoneToken[timezoneToken.length - 1] >= '0' && timezoneToken[timezoneToken.length - 1] <= '9'
        && (timezoneToken.length === 5 || timezoneToken[3] === ':');
};

const normalizeOffsetTimezoneToken = (timezoneToken) => (
    timezoneToken.length === 5
        ? `${timezoneToken.slice(0, 3)}:${timezoneToken.slice(3)}`
        : timezoneToken
);

const getWhitespaceStartIndex = (dateValue, index) => {
    let whitespaceStart = index;

    while (whitespaceStart > 0 && dateValue[whitespaceStart - 1] === ' ') {
        whitespaceStart -= 1;
    }

    return whitespaceStart;
};

const normalizeExplicitTimezoneSuffix = (dateValue) => {
    const upperDateValue = dateValue.toUpperCase();

    if (upperDateValue.endsWith(' UTC')) {
        return `${dateValue.slice(0, -4)}Z`;
    }

    if (upperDateValue.endsWith(' HKT')) {
        return `${dateValue.slice(0, -4)}+08:00`;
    }

    return dateValue;
};

const normalizeOffsetTimezoneSpacing = (dateValue) => {
    const trimmedDate = dateValue.trimEnd();
    const lastSpaceIndex = trimmedDate.lastIndexOf(' ');

    if (lastSpaceIndex < 0) {
        return trimmedDate;
    }

    const timezoneToken = trimmedDate.slice(lastSpaceIndex + 1);

    if (!isOffsetTimezoneToken(timezoneToken)) {
        return trimmedDate;
    }

    const whitespaceStart = getWhitespaceStartIndex(trimmedDate, lastSpaceIndex);
    return `${trimmedDate.slice(0, whitespaceStart)}${normalizeOffsetTimezoneToken(timezoneToken)}`;
};

const normalizeTimezoneString = (dateValue) => {
    if (typeof dateValue !== 'string') {
        return dateValue;
    }

    const normalizedDate = normalizeExplicitTimezoneSuffix(dateValue);
    return normalizeOffsetTimezoneSpacing(normalizedDate).replace(' ', 'T');
};

export const parseMaintenanceTimestamp = (dateValue) => {
    if (!dateValue) {
        return NaN;
    }

    if (dateValue instanceof Date) {
        return dateValue.valueOf();
    }

    const rawDate = String(dateValue).trim();

    if (!rawDate) {
        return NaN;
    }

    if (hasExplicitTimezone(rawDate)) {
        const normalizedDate = normalizeTimezoneString(rawDate);

        return new Date(normalizedDate).valueOf();
    }

    const diffTimestamp = (HK_TIMEZONE_OFFSET - new Date().getTimezoneOffset()) * 60 * 1000;
    return new Date(rawDate.replace(/-/g, '/')).valueOf() + diffTimestamp;
};

export const normalizeMaintenanceWindow = (maintenanceData = {}) => ({
    ...maintenanceData,
    status: typeof maintenanceData.status === 'boolean'
        ? maintenanceData.status
        : !!maintenanceData.maintenanceWindowFlag,
    startDate: maintenanceData.startDate || maintenanceData.startTime || '',
    endDate: maintenanceData.endDate || maintenanceData.endTime || '',
});

export const timeDiffMaintenance = (startDate, endDate) => {
    const localTimestamp = Date.now();
    const startTimestamp = parseMaintenanceTimestamp(startDate);
    const endTimestamp = parseMaintenanceTimestamp(endDate);
    const isValidWindow = Number.isFinite(startTimestamp) && Number.isFinite(endTimestamp);

    return {
        status: isValidWindow && localTimestamp - startTimestamp > 0 && endTimestamp - localTimestamp > 0,
        startFormatStr: isValidWindow ? format(startTimestamp) : '',
        endFormatStr: isValidWindow ? format(endTimestamp) : ''
    };
}

export const format = (dateStr) => {
    const date = new Date(dateStr);
    const YY = date.getFullYear();
    const MM = 9 > date.getMonth() ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
    const DD = 10 > date.getDate() ? '0' + date.getDate() : date.getDate()
    const HH = 10 > date.getHours() ? '0' + date.getHours() : date.getHours();
    const mm = 10 > date.getMinutes() ? '0' + date.getMinutes() : date.getMinutes();
    const ss = 10 > date.getSeconds() ? '0' + date.getSeconds() : date.getSeconds();
    return `${[YY, MM, DD].join('-')} ${[HH, mm, ss].join(':')}`;
}

export const isFutureDate = (compareDate) => {
    return new Date(compareDate).getTime() > Date.now();
}

export const isAfterHKTNewYear2026 = () => {
    const hktNewYear2026 = '2026-01-01T00:00:00+08:00';
    return !isFutureDate(hktNewYear2026);
}
